export default __webpack_public_path__ + "static/media/2_0090.8a2a1f74.webp";